import { configureStore } from '@reduxjs/toolkit';

import appSlice from './features/app/appSlice';
import jobsSlice from './features/job/jobsSlice';
import companiesSlice from './features/company/companiesSlice';
import filesSlice from './features/file/filesSlice';
import invoicesSlice from './features/invoice/invoicesSlice';
import notificationsSlice from './features/notification/notificationsSlice';
import usersSlice from './features/user/usersSlice';
import plansSlice from './features/plan/plansSlice';
import themeSlice from './features/theme/themeSlice';
import applicationsSlice from './features/applications/applicationsSlice';
import candidateSlice from './features/candidate/candidateSlice';
import candidateProfileViewSlice from './features/candidateProfileView/candidateProfileViewSlice';
import messagesSlice from './features/messages/messagesSlice';
import interviewsSlice from './features/interviews/interviewsSlice';
import bundleSlice from './features/bundle/bundleSlice';
import benefitSlice from './features/benefit/benefitSlice';
import supportSlice from './features/support/supportSlice';
import suggestionsSlice from './features/suggestions/suggestionsSlice';
import configurationSlice from './features/configuration/configurationSlice';
import { jobApi, companyApi, userApi, fileApi, invoiceApi, notificationApi, planApi } from './features/api';
// Automatically adds the thunk middleware and the Redux DevTools extension
export const store = configureStore({
  reducer: {
    app: appSlice,
    jobs: jobsSlice,
    companies: companiesSlice,
    files: filesSlice,
    invoices: invoicesSlice,
    notifications: notificationsSlice,
    users: usersSlice,
    plans: plansSlice,
    theme: themeSlice,
    applications: applicationsSlice,
    candidate: candidateSlice,
    candidateProfileView: candidateProfileViewSlice,
    messages: messagesSlice,
    interviews: interviewsSlice,
    bundle: bundleSlice,
    benefit: benefitSlice,
    support: supportSlice,
    suggestions: suggestionsSlice,
    configuration: configurationSlice,
    // Add the generated RTK Query "API slice" caching reducer
    [jobApi.reducerPath]: jobApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [invoiceApi.reducerPath]: invoiceApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [planApi.reducerPath]: planApi.reducer
  },
  // Add the RTK Query API middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(jobApi.middleware)
      .concat(companyApi.middleware)
      .concat(userApi.middleware)
      .concat(fileApi.middleware)
      .concat(invoiceApi.middleware)
      .concat(notificationApi.middleware)
      .concat(planApi.middleware)
});
